import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Forma from '../components/Forma'
import { FormattedMessage, injectIntl } from "gatsby-plugin-intl"

import mail from '../images/icon-mail.svg'
import phone from '../images/icon-phone.svg'

const Recursos = ({intl}) => (
  	<Layout>

		<SEO
			title={intl.formatMessage({ id: "contacto.titulo" })}
			description={intl.formatMessage({ id: "contacto.subtitulo" })}
		/>

		<section className="contacto">

			<div className="heading-banner-simple">
				<div className="cont">
					<div className="titulo">
						<h1><FormattedMessage id="contacto.subtitulo" /></h1>
					</div>
				</div>
			</div>

			<div className="cont">
				<div className="formulario">
					<p className="mb-5"><FormattedMessage id="contacto.descripcion" /></p>
					<Forma/>
				</div>
				<div className="info">
					<ul>
						<li>
							<a href="mailto:hello@akzent.mx">
								<img src={mail} alt="Mail" width="18" height="14"/>
								<strong>hello@akzent.mx</strong>
							</a>
						</li>
						<li>
							<a href="tel:(800)2259368">
								<img src={phone} alt="Tel" width="14" height="14"/>
								<div>
									<FormattedMessage id="footer.mexico" />
									<small className="d-block"><FormattedMessage id="footer.sincosto" /></small>
								</div>
								<strong>(800) 2259368</strong>
							</a>
						</li>
						<li>
							<a href="tel:18669236330">
								<img src={phone} alt="Tel" width="14" height="14"/>
								<div>
									<FormattedMessage id="footer.usa" />
									<small className="d-block"><FormattedMessage id="footer.sincosto" /></small>
								</div>
								<strong>1 866 9236330</strong>
							</a>
						</li>
						<li>
							<p>Av. del Roble 701, Valle del Campestre, 66265 San Pedro Garza García, N.L.</p>
						</li>
					</ul>
				</div>
			</div>
		</section>

		<div className="mapa-frame">
			<iframe title="Mapa" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3596.6275873322643!2d-100.35547904917802!3d25.650482819374734!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8662bde24c4e8661%3A0x90f0f8bbcc404e03!2sAkzent+Logistics+S.A.+de+C.V.!5e0!3m2!1ses-419!2smx!4v1560198781628!5m2!1ses-419!2smx" width="600" height="450" frameBorder="0" style={{border:0}} allowFullScreen></iframe>
		</div>

  </Layout>
)

export default injectIntl(Recursos)
